export const apiBaseUrl = "https://api.goldbee.in";

export const api = async (url, options = {}) => {
  const res = await fetch(`${apiBaseUrl}${url}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      ...(options.headers || {}),
    },
  });
  return res.json();
};

// Store token in memory for API calls
let accessToken = null;

export const setAuthToken = (token) => {
  accessToken = token;
};
